// componentes/MultiSelectFilter.jsx
import React, { useState, useRef, useEffect } from 'react';
import { ChevronDown, Search } from 'lucide-react';

const MultiSelectFilter = ({ label, options = [], selected = [], onChange }) => {
  const [isOpen, setIsOpen] = useState(false);
  const [searchTerm, setSearchTerm] = useState('');
  const dropdownRef = useRef(null);

  useEffect(() => {
    const handleClickOutside = (e) => {
      if (dropdownRef.current && !dropdownRef.current.contains(e.target)) setIsOpen(false);
    };
    document.addEventListener('mousedown', handleClickOutside);
    return () => document.removeEventListener('mousedown', handleClickOutside);
  }, []);

  const filteredOptions = options.filter(opt => {
    const optLabel = typeof opt === 'string' ? opt : opt.label;
    return optLabel.toLowerCase().includes(searchTerm.toLowerCase());
  });

  const toggleOption = (value) => {
    if (selected.includes(value)) {
      onChange(selected.filter(v => v !== value));
    } else {
      onChange([...selected, value]);
    }
  };

  const selectAll = () => {
    if (selected.length === options.length) {
      onChange([]);
    } else {
      onChange(options.map(opt => typeof opt === 'string' ? opt : opt.value));
    }
  };

  return (
    <div className="filter-pill-container2" ref={dropdownRef}>
      <button
        className={`filter-pill-button2 ${selected.length > 0 ? 'active' : ''}`}
        onClick={() => setIsOpen(!isOpen)}
        type="button"
      >
        <span className="pill-label2">{label}:</span>
        <span className="pill-value2">{selected.length} selec.</span>
        <ChevronDown size={11} className={`pill-arrow2 ${isOpen ? 'up2' : ''}`} />
      </button>
      {isOpen && (
        <div className="filter-dropdown-panel2">
          <div className="search-wrapper2">
            <Search size={14} />
            <input
              type="text"
              placeholder="Buscar..."
              value={searchTerm}
              onChange={(e) => setSearchTerm(e.target.value)}
              autoFocus
            />
          </div>
          <div className="options-list2">
            <div className="checkbox-row2" onClick={selectAll}>
              <input type="checkbox" checked={selected.length === options.length} onChange={selectAll} />
              <span>Seleccionar Todos</span>
            </div>
            {filteredOptions.map((opt, i) => {
              const value = typeof opt === 'string' ? opt : opt.value;
              const label = typeof opt === 'string' ? opt : opt.label;
              return (
                <div key={i} className="checkbox-row2" onClick={() => toggleOption(value)}>
                  <input type="checkbox" checked={selected.includes(value)} onChange={() => {}} />
                  <span>{label}</span>
                </div>
              );
            })}
          </div>
        </div>
      )}
    </div>
  );
};

export default MultiSelectFilter;